export default __webpack_public_path__ + "static/media/dynamic-fund-coffee-desbanner.6ddd424c.jpg";